
import React, { useState } from "react";
import { Odd } from "../../../../models/Odd_response_model.tsx";
import { useBetContext } from "../../../../context/ParlayBetContext.tsx";
import { formatNumber } from "../../../../helpers/functions.tsx";
import { BetDetails } from "../../../../models/MyBetModel.tsx";


export function SelectedOddParlay({ o, onRequestBetsModal, currentBet, slotIndex }: { o: Odd, onRequestBetsModal: Function, currentBet?: BetDetails, slotIndex: number }) {
    const { bets } = useBetContext();
    const [windowWidth] = useState(window.innerWidth);
    const inputId = `parlay-${o.id}`;

    function buildControlForPrefix(): React.ReactNode {
        if (!o) return null;

        switch (slotIndex) {

            // SLOT 0 → S
            case 0:
                return (
                    <span className="betOveU">
                        {formatNumber(o.points, undefined, "points")} {formatNumber(o.price)}
                    </span>
                );

            // SLOT 1 → M
            case 1:
                return (
                    <span className="betOveU">
                        {formatNumber(o.price)}
                    </span>
                );

            // SLOT 2 → total
            case 2: {
                if (!o.selection_line) return null;

                const isOver = o.selection_line.toLowerCase() === 'over';

                if (isOver) {
                    return (
                        <>
                            <span className="under-texbox">
                                {windowWidth <= 960 ? 'O' : 'Over'}
                            </span>
                            <span className={`betOveU adjust-price-total-o`}>
                                {formatNumber(o.price)}
                            </span>
                            <span className="prefix-betPoint-total">{formatNumber(o.points, undefined, "unsigned")}</span>
                        </>
                    );
                }

                // Under
                return (
                    <>
                        <span className="under-texbox">
                            {windowWidth <= 960 ? 'U' : 'Under'}
                        </span>
                        <span className={`betOveU adjust-price-total-u`}>
                            {formatNumber(o.price)}
                        </span>
                    </>
                );

            }

            case 3: {
                const isOver = o.selection_line.toLowerCase() === 'over';

                if (isOver) {
                    return (
                        <>
                            <span className="over-texbox">
                                {windowWidth <= 960 ? 'O' : 'Over'}
                            </span>
                            <span className="betOveU">
                                {formatNumber(o.price)}
                            </span>
                        </>
                    );
                }

                // Under
                return (
                    <>
                        <span className="under-texbox">
                            {windowWidth <= 960 ? 'U' : 'Under'}
                        </span>
                        <span className="prefix-betPoint">
                            {formatNumber(o.points, undefined, "unsigned")}
                        </span>
                        <span className="betOveU">
                            {formatNumber(o.price)}
                        </span>
                    </>
                );
            }

            default:
                return null;
        }
    }
    
    return (
        <>

            <div className={`${"large-screen"} ${o.selection_line}`}>
                <div className="future-container-name">
                    {o && (
                        <label className="select-box">
                            {`${formatNumber(o.points, o.selection_line, "points")} ${formatNumber(o.price)}`}
                        </label>
                    )}
                </div>

                <div className="input-container-bet">
                    <input id={inputId} type="checkbox" className="checkboxParlay"
                        checked={bets.some(b => b.id_selection === o.id)}
                        onChange={(e) => { onRequestBetsModal({ odd: o }, e.target.checked) }}
                    />
                </div>
            </div>

            <label className={`small-screen ${bets.some(b => b.id_selection === o.id) ? "selected" : ""}`} htmlFor={inputId} >
                {buildControlForPrefix()}
            </label>


        </>
    );
}
